const config = {
  apiUrl: process.env.NODE_ENV === "production" ? "https://dancehall.su/api/v1" : "http://localhost:8080/api/v1",
}

export default Object.freeze(config)
